import React from "react";

function Messages({ msg, desc }) {
  return (
    <div className="Message">
      <h1>{msg}</h1>
      <p id="msg">{desc}</p>
    </div>
  );
}

export default Messages;
